import React from 'react';
import { Toast } from './Toast';
import { useToasts } from '../context/NotificationContext';

export const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToasts();
  
  // Limit to maximum 3 visible toasts
  const visibleToasts = toasts.slice(0, 3);

  return (
    <div className="toast-container" aria-live="polite" aria-label="Notifications">
      {visibleToasts.map((toast) => (
        <Toast
          key={toast.id}
          id={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={removeToast}
        />
      ))}
    </div>
  );
};